<template>
    <div class="p-3">
        <div class="text-sm text-muted text-uppercase">
            {{ label }}
        </div>

        <div class="text-lg text-blue-600 font-weight-bold">
            {{ departureDate }} {{ departureTime }}
        </div>

        <div>
            {{ startPlace }} - {{ endPlace }}
        </div>

        <div class="d-flex align-items-center justify-content-between mt-2 text-blue-600 font-weight-bold">
            <div>
                {{ $t('price') }}:
            </div>

            <div class="text-lg">
                {{ formatPrice(price, travel.currency) }}
            </div>
        </div>

        <cart-additional-options></cart-additional-options>
    </div>
</template>

<script>
    import CartAdditionalOptions from './CartAdditionalOptions';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            CartAdditionalOptions,
        },

        props: {
            label: {
                type: String,
                required: true,
            },

            departureDate: {
                type: String,
                required: true,
            },

            departureTime: {
                type: String,
                required: true,
            },

            startPlace: {
                type: String,
                required: true,
            },

            endPlace: {
                type: String,
                required: true,
            },

            travel: {
                type: Object,
                required: true,
            },
        },

        computed: {
            ...mapGetters({
                additionalOptionsTotal: 'familyAirportTaxi/additionalOptionsTotal',
            }),

            price() {
                return this.travel.gross_price + this.additionalOptionsTotal;
            },
        },
    };
</script>
